document.querySelectorAll('[data-awol-collection-tabs]').forEach(function (root) {
  var triggers = root.querySelectorAll('[data-awol-tab-trigger]');
  var panels = root.querySelectorAll('[data-awol-tab-panel]');

  triggers.forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var index = trigger.getAttribute('data-index');

      triggers.forEach(function (t) {
        var isActive = t.getAttribute('data-index') === index;
        t.classList.toggle('is-active', isActive);
        t.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      panels.forEach(function (panel) {
        var isActive = panel.getAttribute('data-index') === index;
        panel.classList.toggle('is-active', isActive);
        if (isActive) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });
    });
  });
});
